import { CalendarClock } from "lucide-react";

/**
 * Placeholder (SPEC §4 T2). Scope previsto: tracking delle scadenze di
 * pagamento (tranche €20K/€20K/€20K/€10K + canone). Non implementato in questo giro.
 */
export function AdminEconomiaScadenzePage() {
  return (
    <div className="mx-auto max-w-2xl py-10 text-center">
      <div className="mx-auto mb-4 grid size-14 place-items-center rounded-2xl bg-muted">
        <CalendarClock className="size-7 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-bold tracking-tight">Scadenze e pagamenti</h1>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
        Qui terremo traccia delle scadenze di pagamento del contratto (le tranche e
        il canone) con lo stato di ciascuna. In arrivo in un prossimo rilascio.
      </p>
      <span className="mt-4 inline-block rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold text-brand-700">
        In arrivo
      </span>
    </div>
  );
}
